import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

export const csrfInterceptor: HttpInterceptorFn = (req, next) => {
  const document = inject(DOCUMENT);
  
  // Find the meta tag with name="csrf-token"
  const csrfMetaTag = document.querySelector('meta[name="csrf-token"]');
  const csrfToken = csrfMetaTag ? csrfMetaTag.getAttribute('content') : null;

  if (csrfToken) {
    // Clone the request and add the CSRF token header
    const clonedReq = req.clone({
      headers: req.headers.set('X-CSRF-TOKEN', csrfToken)
    });
    return next(clonedReq);
  }

  // If no token, just pass the original request
  return next(req);
};
